import * as actions from "./actionTypes";
import axios from "../../axios_call";
import swal from "sweetalert";
import { BASE_URL } from "../../components/Helpers/helpers";

const transactionListStart = () => {
  return {
    type: actions.TRANSACTION_LIST_START,
  };
};

const transactionListFail = (error) => {
  return {
    type: actions.TRANSACTION_LIST_FAIL,
    error: error,
  };
};

const transactionListSuccess = (message, data, page) => {
  return {
    type: actions.TRANSACTION_LIST_SUCCESS,
    message: message,
    data: data,
    page: page,
  };
};

const transactionDeleteAction = (id) => {
  return {
    type: actions.TRANSACTION_DELETE,
    id: id,
  };
};

const transactionAddEditStart = () => {
  return {
    type: actions.TRANSACTION_ADD_EDIT_START,
  };
};

const transactionAddEditFail = (error) => {
  return {
    type: actions.TRANSACTION_ADD_EDIT_FAIL,
    error: error,
    redirectTo: null,
  };
};

const transactionAddEditSuccess = (message, data) => {
  return {
    type: actions.TRANSACTION_ADD_EDIT_SUCCESS,
    message: message,
    data: data,
    redirectTo: "/transactions",
  };
};

const transactionDetail = (data, error) => {
  return {
    type: actions.TRANSACTION_DETAIL,
    data: data,
    error: error,
  };
};

const transactionStatus = (data, error) => {
  return {
    type: actions.TRANSACTION_STATUS,
    data: data,
    error: error,
  };
};

const transactionfilterList = (text) => {
  return {
    type: actions.TRANSACTION_LIST_FILTER,
    text: text,
  };
};
const constructUrlWithParams = (baseUrl, params) => {
  const query = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");
  return `${baseUrl}?${query}`;
};

export const transactionList = (params) => {
  return (dispatch) => {
    dispatch(transactionListStart());

    const url = constructUrlWithParams(`${BASE_URL}/invoice`, params);

    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          const data = response.data.data;
          const msg = response.data.message;
          dispatch(transactionListSuccess(msg, data, params.page)); 
        } else {
          dispatch(transactionListFail(response.message));
        }
      })
      .catch((error) => {
        dispatch(transactionListFail(error.message));
      });
  };
};

export const getAlltransactionList = (params) => {
  return (dispatch) => {
    return axios
      .get(`${BASE_URL}/transaction`)
      .then((response) => {
        if (response.status === 200 ) {
          dispatch(transactionDetail(response.data, "")); 
          return response;
        } else {
          dispatch(transactionDetail(null, "Invalid transaction detail"));
          return { data: null }; 
        }
      })
      .catch((error) => {
        dispatch(transactionDetail(null, error.message));
        return { data: null }; 
      });
  };
};

export const gettransactionupdate = (BankTransactionID, UserID, CurrentLoginedUserId) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/bankFeed/update-transaction-user`, {
        BankTransactionID: BankTransactionID,
        UserID: UserID,
        CurrentLoginedUserId: CurrentLoginedUserId,
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch(transactionDetail(response.data, ""));
          dispatch(getAlltransactionList());
          swal("Poof! Your Details have been saved!", {
            icon: "success",
          });
            return response;
        } else {
          dispatch(transactionDetail(null, "Invalid transaction detail"));
          swal("Error", "Something went to wrong!", "error");
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(transactionDetail(null, error.message));
        return { data: null };
      });
  };
}; 

export const transactionDelete = (id, token) => {
  return (dispatch) => {
    axios
      .delete("SuperAdmin/deletetransaction?transactionid=" + id)
      .then((response) => {
        if (response.data.status) {
          dispatch(transactionDeleteAction(id));
        }
      });
  };
};

export const gettransactionDetail = (id) => {
  return (dispatch) => {
    return axios
      .get(`${BASE_URL}/bankFeed/transaction-detail/${id}`)
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(transactionDetail(response.data, "")); 
          return response; 
        } else {
          dispatch(transactionDetail(null, "Invalid transaction detail"));
          return { data: null }; 
        }
      })
      .catch((error) => {
        dispatch(transactionDetail(null, error.message));
        return { data: null }; 
      });
  };
};

export const getApprovedTranscationStatus = (BankTransactionID, currentUserId) => {
  return (dispatch) => {
    return axios
    .post(`${BASE_URL}/bankFeed/update-transaction-status`, {
      BankTransactionID,
      currentUserId
    })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(transactionDetail(response.data, ""));
          return response;
        } else {
          dispatch(transactionDetail(null, "Failed to update transaction status."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(transactionDetail(null, error.message));
        return { data: null };
      });
  };
};

export const getDeletedTranscation = (BankTransactionID) => {
  return (dispatch) => {
    return axios
    .post(`${BASE_URL}/bankFeed/delete-transaction-document`, {
      BankTransactionID,
    })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(transactionDetail(response.data, ""));
          return response;
        } else {
          dispatch(transactionDetail(null, "Failed to delete transaction document."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(transactionDetail(null, error.message));
        return { data: null };
      });
  };
};

export const getVerifiedTranscationStatus = (BankTransactionID, currentUserId) => {
  return (dispatch) => {
    return axios
    .post(`${BASE_URL}/bankFeed/verified-transcation`, {
      BankTransactionID,
      currentUserId
    })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(transactionDetail(response.data, ""));
          return response;
        } else {
          dispatch(transactionDetail(null, "Failed to update transaction status."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(transactionDetail(null, error.message));
        return { data: null };
      });
  };
};

export const getUnverifiedTranscation = (BankTransactionID) => {
  return (dispatch) => {
    return axios
    .post(`${BASE_URL}/bankFeed/delete-transaction-document`, {
      BankTransactionID,
    })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(transactionDetail(response.data, ""));
          return response;
        } else {
          dispatch(transactionDetail(null, "Failed to delete transaction document."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(transactionDetail(null, error.message));
        return { data: null };
      });
  };
};

export const postTranscationAttachmentsFilename = (BankTransactionID, OrganisationID, fileName) => {
  return (dispatch) => {
    return axios
    .post(`${BASE_URL}/bankFeed/:BankTransactionID/Attachments/:FileName`, {
      BankTransactionID,
      OrganisationID,
      fileName,
    })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(transactionDetail(response.data, ""));
          dispatch(getAlltransactionList());
          swal("Poof! Your Details have been saved!", {
            icon: "success",
          });
            return response;
        } else {
          dispatch(transactionDetail(null, "Failed to delete transaction document."));
          return { data: null };
        }
      })
      .catch((error) => {
        dispatch(transactionDetail(null, error.message));
        return { data: null };
      });
  };
};

export const setTransactionStatus = (id) => {
  return (dispatch) => {
    return axios
      .post(`${BASE_URL}/bankFeed/read-transaction-status/${id}`)
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(transactionStatus(response.data, "")); 
          return response; 
        } else {
          dispatch(transactionStatus(null, "Invalid transaction detail"));
          return { data: null }; 
        }
      })
      .catch((error) => {
        dispatch(transactionStatus(null, error.message));
        return { data: null }; 
      });
  };
};

export const TransactionDetail = (id) => {
  return (dispatch) => {
    axios.get("SuperAdmin/gettransactionbyid?id=" + id).then((response) => {
      if (response.data.result) {
        dispatch(transactionDetail(response.data.result, ""));
      } else {
        dispatch(transactionDetail(null, "Invalide transaction Detail"));
      }
    });
  };
};

export const transactionAddEdit = (param) => {
  return (dispatch) => {
    dispatch(transactionAddEditStart());
    axios
      .post("SuperAdmin/addupdatetransaction", param)
      .then((response) => {
        if (response.data.status) {
          const data = response.data.result;
          const msg = response.data.message;
          dispatch(transactionAddEditSuccess(msg, data));
        } else {
          dispatch(transactionAddEditFail(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(transactionAddEditFail(error.message));
      });
  };
};

export const addEditTransactionErrorNull = () => {
  return (dispatch) => {
    dispatch(transactionAddEditFail(null));
  };
};

export const transactionListFilter = (filterText) => {
  return (dispatch) => {
    dispatch(transactionfilterList(filterText));
  };
};
